import React, { useState } from 'react';
import { AvButton, Loading } from '@fabric-ui/components';
import { Prefix, PrefixColored } from '@fabric-ui/icons';
import { ButtonProps, SxProps, Theme } from '@mui/material';
import { copilotConfig } from './constants';
import { AgentId } from './types';

interface ICopilotButton {
  isOpen: boolean;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  sx?: SxProps<Theme>;
  agentId: AgentId;
  size?: ButtonProps['size'];
  isLoading?: boolean;
  disabled?: boolean;
  disabledToolTip?: string;
}

const CopilotButton = ({ isOpen, onClick, sx = {}, agentId, size = 'xSmall', isLoading, disabled, disabledToolTip }: ICopilotButton) => {
  const [hover, setHover] = useState(false);
  return (
    <AvButton
      aria-label="copilot-button"
      loading={isLoading}
      disabled={disabled}
      tooltip={disabled && disabledToolTip ? disabledToolTip : copilotConfig[agentId]?.title || 'ZAgent'}
      sx={{
        position: 'relative',
        isolation: 'isolate',
        overflow: 'hidden',
        px: size === 'small' ? '7px' : undefined,
        py: size === 'small' ? '5px' : undefined,
        flexShrink: 0,
        opacity: disabled ? 0.5 : 1,
        border: `1px solid ${isOpen || hover ? 'var(--color-border-interactive-primary-default)' : 'transparent'}`,
        transition: theme => theme.transitions.create(['border', 'background'], { duration: theme.transitions.duration.shorter }),
        '&:before': {
          content: '""',
          width: '100%',
          height: '100%',
          background: 'linear-gradient(92deg, #A14CE4 0.5%, #2160E0 99.36%)',
        },
        '&:before, svg:last-of-type': {
          position: 'absolute',
          opacity: isOpen || hover ? 0 : 1,
          transition: theme => theme.transitions.create(['opacity'], { duration: theme.transitions.duration.shorter }),
        },
        ...sx,
      }}
      variant="outlined"
      size={size}
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}>
      {isLoading ? (
        <Loading height={20} color="white" />
      ) : (
        <>
          <PrefixColored />
          <Prefix style={{ color: 'white' }} />
        </>
      )}
    </AvButton>
  );
};

export default CopilotButton;
